//Contains methods for accessing the info controller
import WrapperService from "@/modules/core/services/wrapper-service";
import EnumService from "@/modules/core/services/enum-service";

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/info'
const API_ROOT_URL = process.env.VUE_APP_ROOT_API + '/api/v1';

const serviceName = "Info-Service: ";

export default class InfoService {
  static readAndTranslateEnum(enumPath, utilsTranslationPath, successF, errorF) {
    this.readEnum(enumPath,
        (res) => {
          successF(EnumService.translateAndSortEnum(res.data, utilsTranslationPath));
        },
        errorF
    )
  }

  static async readEnum(value, successF, errorF) {
    await WrapperService.get(API_URL + "/enum/" + value, null, serviceName, successF, errorF);
  }

  static async readOptions(path, successF, errorF) {
    await WrapperService.get(`${API_URL}/${path}/`,
      null,
      serviceName,
      (response) => {
        let options = response.data;
        for (let i = 0; i < options.length; i++) {
          options[i].translatedName = options[i].name;
        }

        if (successF) {
          successF(options);
        }
      },
      errorF);
  }

  static async readOptionsByUrl(url, successF, errorF) {
    await WrapperService.get(`${API_ROOT_URL}/${url}`,
      null,
      serviceName,
      (response) => {
        let options = response.data;
        for (let i = 0; i < options.length; i++) {
          options[i].translatedName = options[i].name;
        }

        if (successF) {
          successF(options);
        }
      },
      errorF);
  }
}
